/**
 * MTL — Native Finish picker: GOLD PRESELECTED (2026-08-11)
 *
 * REPLACES the 2026-07-23 "native finish gate", which cleared the server's
 * default-selected finish and disabled Add to Cart until the customer picked a
 * finish ("Choose your finish first"). That gate left every visitor — including
 * every Pinterest click — on a PDP they could not buy from.
 *
 * Every one of the 62 Finish products lists "Gold - 18K PVD" as its FIRST option
 * value, so product.selected_or_first_available_variant is already the gold
 * variant: the server renders the gold radio checked, binds the gold variant and
 * renders the gold image. The old gate un-picked it in the browser. The data
 * layer was right; only the UI was out of step.
 *
 * Behaviour now:
 *   - if the server already rendered a finish selected (the normal case) this
 *     file does NOTHING - Horizon's native picker is left completely alone,
 *   - only if NOTHING is selected does it select the Gold radio and fire a
 *     bubbling `change` so Horizon binds the variant, price and image natively,
 *   - Add to Cart and the accelerated buttons are never disabled or relabelled.
 *
 * Unchanged from the old file: keys on the option NAME "Finish" + radio inputs
 * (never the display style), requires >= 2 radios (single-finish products are
 * skipped), and skips the custom personalizer PDPs ([data-mtl-personalization]/
 * form.mtl-p), which run their own finish logic.
 *
 * Products with no Finish option at all (the 24 signet rings, Size-only; the 2
 * sliding-bar paw necklaces, Color/Size) never match and are untouched.
 *
 * Reversible: restore from the dated snapshot in Ops/snapshots/.
 */
(function () {
  'use strict';

  function isGold(value) {
    var v = String(value || '').toLowerCase();
    return v.indexOf('gold') > -1 && v.indexOf('rose') === -1;
  }

  function initPicker(picker) {
    if (picker.dataset.mtlFinishPreselect === 'init') return;

    var finishFieldset = null;
    var fieldsets = picker.querySelectorAll('fieldset.variant-option');
    Array.prototype.forEach.call(fieldsets, function (fs) {
      if (finishFieldset) return;
      var byData = fs.getAttribute('data-option-name');
      var legend = fs.querySelector('legend');
      var legendText = legend ? (legend.textContent || '') : '';
      var hasFinishInput = fs.querySelector('input[type="radio"][name^="Finish-"]');
      if (byData === 'Finish' || /finish/i.test(legendText) || hasFinishInput) {
        finishFieldset = fs;
      }
    });
    if (!finishFieldset) return;

    var radios = Array.prototype.slice.call(
      finishFieldset.querySelectorAll('input[type="radio"]')
    );
    if (radios.length < 2) return;

    picker.dataset.mtlFinishPreselect = 'init';

    var alreadyChecked = radios.some(function (r) { return r.checked; });
    if (alreadyChecked) {
      picker.dataset.mtlFinishPreselect = 'server';
      return;
    }

    var gold = null;
    radios.forEach(function (r) {
      if (gold) return;
      var label = finishFieldset.querySelector('label[for="' + r.id + '"]');
      if (isGold(r.value) || isGold(label ? label.textContent : '')) gold = r;
    });
    if (!gold) gold = radios[0];

    gold.checked = true;
    gold.dataset.currentChecked = 'true';
    picker.dataset.mtlFinishPreselect = 'forced';
    gold.dispatchEvent(new Event('input', { bubbles: true }));
    gold.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function init() {
    if (document.querySelector('[data-mtl-personalization], form.mtl-p, [data-self-gated="true"]')) return;
    document.querySelectorAll('variant-picker').forEach(initPicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
